import DisplayTime from '@/components/site/parts/DisplayTime.vue'

import { auth } from '@/components/mixins/auth.js';
import { mapGetters } from 'vuex';
export const myRecommenderList = {    
    data () {
      return {
       
        isLoading:true,        
      }
    },   
    components: {     
      DisplayTime
    }, 
    mixins:[ auth ],
    mounted(){
        this.getRecommender();
    },
    computed:mapGetters({
        recommenderLists:'friend/getRecommender'
    }), 
    methods:{  
        async getRecommender(pagenumber,type){
            const formData = {
                user_id:this.user.id,
                page:pagenumber?pagenumber:1,
                type:type,                
            }
            const response = await this.$store.dispatch("friend/getRecommenderList", formData);
            console.log(response);

            this.isLoading= false;
            this.isLoadMore = false;
            if(this.lastPage <= this.page)
            {
                //alert('더이상 데이터가 없습니다.');
                this.moreData = false;
            }
        },
      
    },
}